import { observer } from "mobx-react-lite";

import { CHAT_BOTTOM_GRADIENT_CLASS } from "./constants";
import { Messages } from "./Messages";
import type { VibeChatStore } from "./stores";

interface VibeChatActiveConversationProps {
  chatStore: VibeChatStore;
  handleRetry: (messageIndex?: number) => void;
}

const VibeChatActiveConversation = observer(
  ({ chatStore, handleRetry }: VibeChatActiveConversationProps) => (
    <>
      <Messages
        messages={chatStore.messages}
        isLoading={chatStore.isLoading}
        chatStore={chatStore}
        onRetry={handleRetry}
      />
      <div className={CHAT_BOTTOM_GRADIENT_CLASS} />
    </>
  ),
);

export default VibeChatActiveConversation;
